/** Socket.IO origin: same host in prod, dev server in development. */
export const SOCKET_URL = process.env.NODE_ENV === 'production' ? '/' : 'http://localhost:3000';

export const COMMUNICATION_FETCH_TIMEOUT_MS = 10000;
export const COMMUNICATION_REQUEST_TIMEOUT = 'COMMUNICATION_REQUEST_TIMEOUT';

/** localStorage: user dismissed the Communication page intro tip. */
export const COMMUNICATION_PAGE_INTRO_DISMISSED_KEY = 'buzzz_communication_page_intro_dismissed_v1';
